import logoImage from "../assets/logo.jpg";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const imagepathReturn = (imageUrl: string) => {
  if (imageUrl) {
    return process.env.REACT_APP_BACKEND_URL + imageUrl;
  }
  return logoImage;
};

export const formatDate = (value: string, format = "DD MMM YYYY") => {
  if (!value) return "-";
  const parsed = dayjs(value, ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY"]);
  if (!parsed.isValid()) return value;
  return parsed.format(format);
};

export const formatTime = (value: string) => {
  if (!value) return "-";
  const parsed = dayjs(value, ["HH:mm:ss", "HH:mm", "h:mm A", "hh:mm A"]);
  if (!parsed.isValid()) return value;
  return parsed.format("hh:mm A");
};
